import { render } from "./Print3DMaterialesPage.vue?vue&type=template&id=31b4548f&scoped=true"
import script from "./Print3DMaterialesPage.vue?vue&type=script&lang=js"
export * from "./Print3DMaterialesPage.vue?vue&type=script&lang=js"

import "./Print3DMaterialesPage.vue?vue&type=style&index=0&id=31b4548f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b4548f"]])

export default __exports__